// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { productCompareFlyOutStyles } from "@steiner/Overrides/Components/ProductCompareFlyOut";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    cssOverrides: {
        scrim: css`
            transition: 300ms ease-in-out;
            background: transparent;
            pointer-events: none;
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerBody: css`
            background: linear-gradient(
                to bottom,
                transparent 0%,
                transparent 40%,
                ${color("common.white", 1)} 40%,
                ${color("common.white", 1)} 100%
            );
            box-shadow: none;
        `,
        drawerContent: css`
            background-color: transparent;
            overflow-y: hidden;
            ${xScreen("lte", "xs")} {
                height: 100%;
            }
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        padding: 16px 0;
        background: ${color("common.white")};
        border-top: 1px solid ${color("common.border")};
        pointer-events: all;
        ${xScreen("lte", "xs")} {
            height: 100%;
        }
    `,
};

productCompareFlyOutStyles.carouselDrawerPage = {
    css: css`
        display: flex;
        align-items: flex-start;
        justify-content: center;
        &&& {
            background: inherit;
            gap: 24px;
            padding: 0 16px;
        }
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    css: css`
        position: absolute;
        right: 4px;
        top: 4px;
        padding: 0;
        &:hover {
            ${IconWrapper} {
                color: ${color("common.ui9")};
            }
        }
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    variant: "tertiary",
    sizeVariant: "small",
    css: css`
        width: 100%;
    `,
};

productCompareFlyOutStyles.headerCompareButton = {
    sizeVariant: "small",
    css: css`
        width: 100%;
    `,
};

productCompareFlyOutStyles.compareHeaderStyles = {
    container: {
        css: css`
            &&&&& {
                padding: 0 16px;
                height: 36px;
                background-color: transparent;
            }
        `,
    },
    titleText: {
        size: 16,
        weight: "bold",
        color: "common.white",
        css: css`
            letter-spacing: 0;
            line-height: 18px;
        `,
    },
    toggle: {
        css: css`
            display: flex;
            gap: 8px;
            align-items: center;
            justify-content: center;
            padding: 6px 25px;
            background: ${color("primary")};
            border-radius: 4px 4px 0 0;
            pointer-events:all;
            &:focus {
                outline: none;
            }
        `,
    },
    icon: {
        size: 24,
        color: "common.white",
    },
};

productCompareFlyOutStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;
        max-width: 262px;
        width: 100%;
        gap: 8px 16px;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
        }
        ${xScreen("lte", "sm")} {
            max-width: unset;
        }
    `,
};

productCompareFlyOutStyles.slidesWrapper = {
    css: css`
        display: none;
        width: 100%;
        gap: 8px;
        ${xScreen("gte", "md")} {
            display: flex;
            justify-content: center;
        }
        ${xScreen("gte", "lg")} {
            gap: 64px;
        }
    `,
};

productCompareFlyOutStyles.slideItem = {
    css: css`
        width: 96px;
        height: 96px;
        scroll-snap-align: start;
       
        & div {
            box-shadow: none;
        }
    `,
};